<template>
  <el-dialog :title="$t('batchTasks.FailedToLoad')" :visible.sync="dialogTableVisible" @close="close">
    <div style="margin-bottom: 20px">
      <el-popover placement="top" width="400" trigger="click">
        <el-input type="textarea" :autosize="{ minRows: 4 }" v-model="searchParams.spus" @blur="spusBlur"></el-input>
        <el-input :placeholder="$t('batchTasks.contentPlaceholder2')" style="width: 476px" class="searchInput" v-model="spusOut" slot="reference"></el-input>
      </el-popover>
      <el-button icon="el-icon-search" type="success" class="searchButton" @click="resetPage"></el-button>
    </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="taskNo" :label="$t('batchTasks.Number')" ></el-table-column>
        <el-table-column :label="$t('batchTasks.StoreInformation')" align="center">
                <template slot-scope="scope">
                  <div class="f-a">
                    <div class="f">
                      <img src="@/assets/img/shopify-store.png" style="width: 20px;height: 20px;margin-right: 4px" v-if="scope.row.platformCode.toUpperCase() === 'SP'">
                      <img src="@/assets/img/dianjiang11.png" style="width: 20px;height: 20px;margin-right: 4px" v-else-if="scope.row.platformCode.toUpperCase() === 'DJ'">
                      <img src="@/assets/img/woocommerce.png" style="width: 20px;height: 20px;margin-right: 4px" v-else-if="scope.row.platformCode.toUpperCase() === 'WC'">
                      <img src="@/assets/img/shopLine-store.png" style="width: 20px;height: 20px;margin-right: 4px" v-else-if="scope.row.platformCode.toUpperCase() === 'SL'">
                      <img src="@/assets/img/tiktok.png" style="width: 20px;height: 20px;margin-right: 4px" v-else-if="scope.row.platformCode.toUpperCase() === 'TT'">
                      {{ scope.row.storeName }}
                    </div>
                  </div>
                </template>
            </el-table-column>
        <el-table-column prop="spu" :label="$t('batchTasks.ItemNo')"></el-table-column>
        <el-table-column prop="errorInfo" :label="$t('batchTasks.ReasonForFailure')" width="500"></el-table-column>
    </el-table>
    <div style="text-align: right">
        <!-- <el-pagination layout="prev, pager, next" :total="total" class="myPagination" :current-page.sync="searchParams.pageNumber" :page-size="searchParams.pageSize" @current-change="getList"></el-pagination> -->
        <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[20, 50, 100, 200]"
            :total="total"
            class="myPagination"
            :current-page.sync="searchParams.pageNumber"
            :page-size="searchParams.pageSize"
            @current-change="pageCurrentChange"
            @size-change="pageSizeChange"/>
    </div>
  </el-dialog>
</template>

<script>
import API from '@/api'
export default {
  data() {
    return {
      searchParams: {
        pageSize: 20,
        pageNumber: 1,
        taskNo: undefined,
        spus: undefined
      },
      tableData: [],
      total: 0,
      dialogTableVisible: false,
      spusOut: ''
    }
  },
  filters: {
    platformName(value) {
      const obj = {
        DJ: 'Shoplazza',
        SP: 'Shopify',
        KA: 'Kakaclo'
      }
      return obj[value]
    }
  },
  methods: {
    resetPage() {
      this.searchParams.pageNumber = 1
      this.getList()
    },
    getParams() {
      const params = Object.assign({}, this.searchParams)
      if (params.spus) {
        params.spus = params.spus.split('\n')
      }
      return params
    },
    async getList() {
      const params = this.getParams()
      const res = await API.getLoadPublishQueueList(params)
      this.tableData = res.data.list
      this.total = res.data.total
    },
    show(row) {
      this.searchParams.taskNo = row.taskNo
      this.getList()
      this.dialogTableVisible = true
    },
    close() {
      this.tableData = []
      this.searchParams.taskNo = undefined
      this.searchParams.spus = undefined
      this.spusOut = undefined
    },
    spusBlur(value) {
      if (value.target.value) {
        this.spusOut = value.target.value.split('\n').join(',')
      } else {
        this.spusOut = ''
      }
    },
    pageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize
      this.getList()
    },
    pageCurrentChange(page) {
      this.searchParams.pageNumber = page
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.inputGroup {
    /deep/.el-input__inner {
        border-top-left-radius: 30px;
        border-bottom-left-radius: 30px;
    }
    /deep/.el-input-group__append {
        border-top-right-radius: 30px;
        border-bottom-right-radius: 30px;
        background-color: rgba(153, 196, 28, 0.2);
    }
}
.myPagination {
  padding: 8px 5px;
  /deep/.number {
      border: 1px solid #D9D9D9;
      margin: 0 5px;
      padding: 0;
      min-width: 30px;
  }
}
.searchButton {
  background-color: #cce28e;
  color: #FFFFFF;
  border-color: #cce28e;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
}
.searchInput {
  /deep/input {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}
</style>
